module.exports = "/_next/static/images/workpal-557bdbcda2180efc64554d9a85b35f4c.svg";